export default {"src":"/_next/static/media/clap.e62da8ed.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};